import * as React from "react";
import { VoucherState } from "../../../services/voucher";
import { VoucherWrap, LCircle, RCircle, Text } from "./styles";
import styled from "styled-components";
import SmartImage from "../../../components/SmartImage";
const VoucherWrapThree = styled(VoucherWrap) `
	overflow-x: scroll;
	&::-webkit-scrollbar {
		height: 0;
	}
	width: auto;
	white-space: nowrap;
	& > div:last-child {
		margin-right: 0 !important;
	}
`;
const VoucherModuleWrapThree = styled.div `
	position: relative;
	width: 9.375rem;
	margin-right: 0.75rem;
	display: inline-block;
`;
const ImgWrap = styled.div `
	width: 100%;
	height: 3.56rem;
	background-color: #fff;
	> img {
		width: 100%;
		height: 100%;
	}
`;
const LeftCircle = styled(LCircle) `
	top: 3.1rem;
`;
const RightCircle = styled(RCircle) `
	top: 3.1rem;
`;
const TextCom = styled(Text) `
	height: 1.75rem;
	.soldOut {
		position: absolute;
		right: 7%;
		top: -82%;
		height: 2.9rem;
	}
`;
const RedeemedStampImg = styled.img `
	position: absolute;
	right: 0.5rem;
	width: 3.75rem;
	bottom: 0.2rem;
`;
export default class VoucherOne extends React.Component {
    constructor() {
        super(...arguments);
        this.renderVoucherCard = (data, index) => {
            var _a;
            const { claimDown, callbackText, icons, baseColor, placeholderBg } = this.props;
            const { img = "", ui, voucherState, link } = data;
            const isFinishOrFullyReceem = voucherState === VoucherState.ComingSoon || voucherState === VoucherState.Expired;
            const styles = { backgroundColor: baseColor || "#f7f7f7" };
            return (React.createElement(VoucherModuleWrapThree, { style: styles, key: index },
                React.createElement(React.Fragment, null,
                    React.createElement(ImgWrap, null,
                        React.createElement(SmartImage, { src: img, qnParams: { w: 750 }, placeholder: placeholderBg, fallbackSrc: placeholderBg, className: "img", style: isFinishOrFullyReceem
                                ? { filter: "grayscale(100%)", opacity: 0.4 }
                                : {} })),
                    React.createElement(TextCom, { style: isFinishOrFullyReceem
                            ? { backgroundColor: "#ddd", color: "#6E6E6E" }
                            : { backgroundColor: ui === null || ui === void 0 ? void 0 : ui.bgColor, color: (_a = ui === null || ui === void 0 ? void 0 : ui.colorTable) === null || _a === void 0 ? void 0 : _a.textColor }, onClick: () => claimDown(data) },
                        React.createElement("a", null, callbackText(voucherState, !!link))),
                    voucherState === VoucherState.RanOut && (React.createElement(RedeemedStampImg, { src: icons, onClick: () => claimDown(data) }))),
                React.createElement(LeftCircle, { style: styles }),
                React.createElement(RightCircle, { style: styles })));
        };
    }
    render() {
        const { vouchers = [], positionId } = this.props;
        return (React.createElement(VoucherWrapThree, { id: positionId }, [...vouchers].map((item, index) => this.renderVoucherCard(item, index))));
    }
}
